import styled from 'styled-components';

const Hero = styled.div`
  & > h4 {
    background-color: ${props => props.theme.table.headerColor};
    text-align: center;
    color: #fff;
    padding: 0.5em;
  }

  & > .carousel {
    margin: 1em 1em 0em 1em;

    h4 {
      color: ${props => props.theme.h5.color};
    }

    img {
      float: left;
      margin-right: 1em;
      width: 100%;

      @media screen and (max-width: ${props => props.theme.breakpoints.small}) {
        width: 100%;
        height: 9em;
      }
    }

    p {
      font-size: 0.8em;
      max-height: 44%;
      overflow: auto;

      @media screen and (max-width: ${props => props.theme.breakpoints.small}) {
        max-height: 4em;
      }
    }
  }

  .contact {
    font-weight: bold;

    span {
      color: ${props => props.theme.buttons.primary.backgroundColor};
    }
  }
`;

export default Hero;
